import React, { useState } from "react";
import { ToggleButton, ToggleButtonGroup, Typography } from "@mui/material";
import { cursoSegunFechaActual } from "../../util/Functions";

const IaxTrimesterSelector = ({value, onChange}) => {
  const [selected, setSelected] = useState(value);

  const handleSelection = (event, newSelected) => {
    if (newSelected !== null) {
      setSelected(newSelected);
      onChange(newSelected);
    }
  };

  return (
    <>
      <Typography component="h1" variant="h5">
        {cursoSegunFechaActual()}
      </Typography>
      <ToggleButtonGroup value={selected} exclusive onChange={handleSelection}>
        <ToggleButton value={1}>1ª eval.</ToggleButton>
        <ToggleButton value={2}>2ª eval.</ToggleButton>
        <ToggleButton value={3}>3ª eval.</ToggleButton>
      </ToggleButtonGroup>
    </>
  );
};

export default IaxTrimesterSelector;
